export default __webpack_public_path__ + "static/media/mobile security.3226e2a5.png";